import * as React from "react";
import NavBar from "../components/common/NavBar";
import TopImage from "../components/common/TopImage";
import Footer from "../components/common/Footer";

function MyComponent() {
  const baseURL = process.env.PUBLIC_URL + '/assets/Uniform';

  const daysData = [
    {
      title: "Weekdays",
      subtitle: " (excluding Wednesday)",
      content: "On weekdays, students are required to wear the regular blue school uniform, their ID card, dark blue socks, and black shoes.",
      images: [`${baseURL}/6.JPG`, `${baseURL}/7.JPG`],
    },
    {
      title: "Wednesday",
      content: "On Wednesdays, students should wear their house t-shirt paired with white pants, along with their ID card. Complete the look with white socks and shoes.",
      images: [`${baseURL}/1.JPG`, `${baseURL}/4.JPG`],
    },
    {
      title: "Saturday",
      content: "On Saturdays, students can wear a comfortable tracksuit paired with their house t-shirt, along with their ID card and with white shoes & socks.",
      images: [`${baseURL}/8.jpg`],
    },
  ];

  return (
    <div>
      <NavBar />
      <TopImage text="Uniform" />
      <div>
        <div className="text-xl tracking-wide text-black mt-20 mx-28 max-md:mx-5 max-md:my-8">
          The students have to come to school in proper school uniforms. The parents are advised to manage the following uniform material for their wards in time. No excuse whatsoever will be accepted. The stitching of the uniform must be as per the pattern given below (also displayed at the school reception).
        </div>
        <div className="text-3xl max-md:mb-2 font-bold tracking-wider text-black capitalize mt-10 mb-6 text-center" >
          Summer
        </div>
      </div>
      <div className="flex flex-col max-w-[930px] mx-auto">
        {daysData.map((day, index) => (
          <div key={index} className="flex flex-col p-6 mt-10 w-full rounded-2xl bg-neutral-50 max-md:px-5 max-md:max-w-full">
            <div className="text-xl tracking-wide text-black capitalize max-md:max-w-full">
              <span className="text-2xl font-bold">{day.title}</span>
              {day.subtitle && <span className="text-2xl"> {day.subtitle}</span>}
            </div>
            <div className="mt-4 text-base tracking-wide text-black max-md:max-w-full">{day.content}</div>
            <div className="flex flex-row max-md:flex-col gap-5 justify-center items-center mt-8">
              {day.images.map((image, imageIndex) => (
                <div key={imageIndex} className="flex flex-row justify-center items-center rounded-lg overflow-hidden">
                  <img
                    loading="lazy"
                    src={image}
                    style={{ width: "240px", height: "340px", backgroundColor: "transparent" }}
                    className="rounded-xl"
                    alt={`Image ${index + 1}-${imageIndex + 1}`}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className="text-3xl font-bold tracking-wider text-black capitalize  mt-10 mb-12 text-center">
        Winter
      </div>
      <div>
        <div className="flex flex-col items-center mx-auto py-6 pr-16 pl-16 mb-20 max-md:mb-8 rounded-2xl bg-neutral-50 max-w-[930px] max-md:px-5">
          <div className="text-base tracking-wide text-black w-[622px] max-md:max-w-full">
            <span className="text-2xl font-bold">Weekdays</span>
            <br />
            <span className="text-l">
              Blazers are mandatory, excluding Saturdays.
            </span>
          </div>
          <div className="flex flex-row max-md:flex-col justify-center items-center gap-5 rounded-lg overflow-hidden mt-8">
    <img
        loading="lazy"
        src={`${baseURL}/9.jpg`}
        style={{ width: "240px", height: "340px", backgroundColor: "transparent" }}
        className="rounded-xl"
        alt="Winter Image"
    />
    <img
        loading="lazy"
        src={`${baseURL}/5.JPG`}
        style={{ width: "240px", height: "340px", backgroundColor: "transparent" }}
        className="rounded-xl"
        alt="Winter Image"
    />
    <img
        loading="lazy"
        src={`${baseURL}/10.jpg`}
        style={{ width: "240px", height: "340px", backgroundColor: "transparent" }}
        className="rounded-xl"
        alt="Winter Image"
    />
</div>

          
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default MyComponent;